import { classifyCanvasNode, isEventNodeKind } from "./nodeKind";
import { EVENT_NODE_ID_PREFIX, isEventNodeId } from "./edgeClassifier";
const NOTHING_SELECTED = {
    kind: "none"
};
/**
 * The start event renders under its raw event id (ADR 0003 P3b). Circle events
 * carry their id in `data.eventId` when persisted; legacy snapshot nodes fall
 * back to the `event-…` tail so the consumer can kick off the lazy upgrade.
 */ function eventIdOf(node, kind) {
    if (kind === "event-start") return node.id;
    const dataEventId = node.data?.eventId;
    if (dataEventId) return dataEventId;
    return isEventNodeId(node.id) ? node.id.slice(EVENT_NODE_ID_PREFIX.length) : node.id;
}
/**
 * Editor selection semantics: an event node opens its event, a recorded step
 * its step, an open assignment its placeholder, and an `unclear` end node the
 * successor slot behind it. The read-only canvas deliberately differs — there
 * an end node opens its PREDECESSOR step's detail (see
 * `ProcessFlowVisualization`), which is a view-only affordance, not a slot to
 * resolve.
 */ export function resolveSelection({ selectedNodeId, nodes, steps, openAssignments }) {
    if (!selectedNodeId) return NOTHING_SELECTED;
    const node = nodes.find((n)=>n.id === selectedNodeId);
    const kind = node ? classifyCanvasNode(node) : undefined;
    if (node && kind && isEventNodeKind(kind)) {
        return {
            kind: "event",
            eventId: eventIdOf(node, kind)
        };
    }
    const step = steps?.find((s)=>s._id === selectedNodeId);
    if (step) return {
        kind: "step",
        step
    };
    const placeholder = openAssignments?.find((a)=>String(a.stableStepId) === selectedNodeId);
    if (placeholder) {
        return {
            kind: "placeholder",
            stableStepId: String(placeholder.stableStepId)
        };
    }
    if (kind === "end") {
        const data = node?.data;
        if (data?.variant === "unclear" && data.predecessorStepId) {
            return {
                kind: "unclear-end",
                predecessorStepId: data.predecessorStepId,
                branchKey: data.branchKey
            };
        }
    }
    return NOTHING_SELECTED;
}

//# sourceMappingURL=resolveSelection.js.map